<script>
export default {
  props: ['label', 'location'],
  data() {
    return {
      input: this.label
    }
  },
  render() {
    return this.$scopedSlots.default({
    //   inputProps: {
    //     value: this.input
    //   },
    //   inputEvents: {
    //     focusout: e => (this.input = e.target.value)
    //   }
    })
  }
}
</script>
